<template>
    <div class="page">
        <div class="header">
            <Header :current="['home']"></Header>
            <div class="zt-title">{{ title }}</div>
        </div>
        <!-- <div class="content" v-html="domData"></div>
        <div class="img" v-for="(item, i) in img" :key="i">
            <img :src="internalInstance.appContext.config.globalProperties.$imgUrl + item.imgs" alt="商品图片">
        </div>
        <div class="content" v-if="resources.length > 0">
            <div class="file-download" v-for="(item, i) in resources" :key="i">
                <div>附件{{ i+1 }}：{{ item.title }}</div>
                <a :href="internalInstance.appContext.config.globalProperties.$imgUrl + item.url">下载文件</a>
            </div>
        </div> -->
        <div class="content">
            <div class="content-html" v-html="domData"></div>
            <div class="content-img" v-if="img.length > 0">
                <img v-for="(img, i) in img" :src="internalInstance.appContext.config.globalProperties.$imgUrl + img" :key="i">
            </div>
            <div class="resources">
                <div class="file-download" v-for="(item, i) in resources" :key="i">
                    <div>附件{{ i+1 }}：{{ item.title }}</div>
                    <a :href="internalInstance.appContext.config.globalProperties.$imgUrl + item.url">下载文件</a>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/portal/Header'
import Footer from "../../components/portal/Footer"
import { ref, getCurrentInstance } from 'vue'
import {useRoute} from "vue-router"
import {getPolicyDetail, getProcessDetail} from "@/api/policy"
export default {
    name: "Articles",
    mounted() {
        this.initData()
    },
    setup() {
        const domData = ref('')
        const title = ref('')
        const resources = ref([])
        const img = ref([])
        const internalInstance = getCurrentInstance()
        return {
            domData,
            title,
            resources,
            img,
            internalInstance
        }
    },
    methods: {
        async initData() {
            const route = useRoute()
            let data
            // const data = await getPolicyDetail(route.query.id)
            if (route.query.title === '农业保险') {
                data = await getProcessDetail('300012&'+route.query.id)
            } else if(route.query.title === '信贷服务') {
                data = await getProcessDetail(route.query.secId+'&'+route.query.id)
            } else {
                data = await getPolicyDetail(route.query.id)
            }
            // const data = await getProcessDetail('300012&'+route.query.id)
            this.title = data.title
            this.domData = data.text
            if(data.imgs) {
                this.img = data.imgs.split(',').filter(function (s) {
                    return s && s.trim()
                })
            }
            this.resources = data.resources
        }
    },
    components: {
        Header,
        Footer
    }
}
</script>

<style scoped lang="stylus">
.page {
    width 100%
    height 100%
    position relative
    font-size 16px
    background-color #FFF
    .header {
        width 100%
        height 730px
        padding 130px 50px 0 50px
        box-shadow 0 23px 120px rgba(0, 0, 0, 0.3)
        border-bottom-left-radius 315px
        border-bottom-right-radius 315px
        background-image url("../../assets/img/portal_home_bg.png")
        background-size 100% 100%
        background-repeat no-repeat
        .zt-title {
            margin-top 200px
            width 100%
            font-size 48px
            color #FFF
            font-weight bold
            text-align center
        }
    }
    .content {
        width 100%
        min-height 200px
        margin-top 30px
        padding 50px 350px
        .content-html {
            //text-indent 42px
        }
        .content-html >>> table {
            width 100%
        }
        .content-html >>> td {
            border 1px solid #000
            padding 5px 10px
            text-align center
        }
        .content-img {
            width 100%
            overflow hidden
            text-align center
        }
        .content-img img {
            width 70%
            margin-bottom 20px
        }
    }
}
</style>